// src/components/dfs/skeletons/LineupSectionSkeleton.tsx
import React from 'react';

const LineupSlotSkeleton: React.FC = () => (
  <div className="flex items-center bg-primary/60 p-2 rounded-md text-xs shadow animate-pulse h-10"> {/* Approx height of a player row */}
    <div className="h-4 bg-gray-600 rounded w-6 mr-2"></div> {/* Slot Position */}
    <div className="h-4 bg-gray-600 rounded flex-grow mr-2"></div> {/* Player Name */}
    <div className="h-4 bg-gray-600 rounded w-12"></div> {/* Score/Salary */}
  </div>
);

const LineupSectionSkeleton: React.FC = () => {
  return (
    <div className="lg:col-span-1 bg-surface-card p-4 rounded-lg shadow-xl flex flex-col border border-gray-700/30 animate-pulse">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <div className="h-6 bg-gray-700 rounded w-1/3"></div> {/* "MY LINEUP" title */}
        <div className="h-7 bg-gray-600 rounded w-1/4"></div> {/* Edit/Build button */}
      </div>
      {/* Salary/Score info */}
      <div className="h-4 bg-gray-700 rounded w-1/2 mb-1"></div>
      <div className="h-6 bg-gray-700 rounded w-1/3 mb-3"></div>
      
      {/* Player Slots */}
      <div className="space-y-1.5 flex-grow overflow-y-auto max-h-[calc(65vh-120px)] min-h-[200px] border-t border-gray-700 pt-2">
        {Array.from({ length: 4 }).map((_, index) => ( // Show a few slot skeletons
          <LineupSlotSkeleton key={`lineup-slot-skel-${index}`} />
        ))}
      </div>
    </div>
  );
};

export default LineupSectionSkeleton;